import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { GalaxyBackground } from './GalaxyBackground';
import PromoPopup from './PromoPopup';
import useDataTracker from '../../hooks/useDataTracker';

export function Layout() {
  useDataTracker();
  return (
    <>
      <GalaxyBackground />
      <div className="app-content">
        <Header />
        <main style={{ minHeight: 'calc(100vh - 140px)', paddingTop: 'var(--header-height, 52px)' }}>
          <Outlet />
        </main>
        <Footer />
      </div>
      <PromoPopup />
    </>
  );
}
